import Nullstack from 'nullstack';
export default function IconRadar2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-radar-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M15.51 15.56a5 5 0 1 0 -3.51 1.44"
  }), "   ", Nullstack.element("path", {
    d: "M18.832 17.86a9 9 0 1 0 -6.832 3.14"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v9"
  }), " ");
}